const Topper = theme => {
  return {
    background: '#fff',
    padding: '7rem 7rem 0 7rem',
    [theme.breakpoints.down('sm')]: {
      padding: '2rem 2rem 0 2rem',
    },
  }
}

export default Topper



// WEBPACK FOOTER //
// ./src/styles/mixins/topper.js